module.exports = __webpack_public_path__ + "img/img-15.cc6c98b0.webp";